import Card, { CardHeader, CardTitle, CardBody } from './Card'
import Pill from './Pill'

export default function HowToRead() {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-8 md:mt-12 mb-6 md:mb-8" aria-label="How to read">
      <Card>
        <CardHeader>
          <CardTitle>How to read this site</CardTitle>
          <Pill accent>Ideating → Iterating → Learnings</Pill>
        </CardHeader>
        <CardBody>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch]">
            Each experiment moves through a simple loop.
          </p>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch] mt-3">
            <strong className="text-text-dark font-semibold">Ideating</strong> — defining the intent and the question worth testing.<br />
            <strong className="text-text-dark font-semibold">Iterating</strong> — taking action and adjusting as reality responds.<br />
            <strong className="text-text-dark font-semibold">Learnings</strong> — extracting signal and deciding what changes next.
          </p>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch] mt-3">
            To engage, open an experiment and follow the record.
          </p>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>What this is</CardTitle>
          <Pill>operating context</Pill>
        </CardHeader>
        <CardBody>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch]">
            This is a place for me to experiment — to try ideas, play with tools, and see what actually happens when something meets the real world.
            It's less about presenting finished work and more about having room to explore, test, and think out loud through action.
          </p>
          <p className="m-0 text-muted-dark leading-[1.7] max-w-[72ch] mt-3">
            Experiments usually start rough. Some get pushed forward, some get reshaped, and some get dropped entirely.
            What matters is capturing the learnings along the way and sharing them openly, as they emerge.
          </p>
        </CardBody>
      </Card>
    </section>
  )
}

